import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { IconButton } from '@totalsoft/rocket-ui';
import { ArrowBack } from '@mui/icons-material';

const HeaderLinks = ({ onClickClose, disabledSave, onSave }) => {
  const { t } = useTranslation();

  return (
    <>
      <IconButton fontSize='medium' color='transparent' tooltip={t('Tooltips.ScoringCategories.BackToList')} onClick={onClickClose}>
        <ArrowBack color='primary' />
      </IconButton>
      <IconButton
        type='save'
        fontSize='medium'
        color='transparent'
        tooltip={t('ScoringCategories.SaveChanges')}
        disabled={disabledSave}
        onClick={onSave}
      />
    </>
  );
};

HeaderLinks.propTypes = {
  onClickClose: PropTypes.func.isRequired,
  disabledSave: PropTypes.bool.isRequired,
  onSave: PropTypes.func.isRequired,
  
};

export default HeaderLinks;
